module.exports = __webpack_public_path__ + "static/media/conexion-bajada-externa.7bd152f6.png";